import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { TokenStoreService } from '../services/token-store.service';

/** Auth endpoints that must NOT receive a Bearer token. */
const AUTH_PASSTHROUGH = ['/auth/login', '/auth/register', '/auth/refresh'];

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private tokenStore: TokenStoreService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.tokenStore.get();
    const isPassthrough = AUTH_PASSTHROUGH.some((path) => req.url.includes(path));

    if (!isPassthrough && token) {
      const tenantId = this.extractTenantId(token);
      const headers: Record<string, string> = { Authorization: `Bearer ${token}` };
      if (tenantId) {
        headers['x-tenant-id'] = tenantId;
      }
      req = req.clone({ setHeaders: headers });
    }

    return next.handle(req);
  }

  private extractTenantId(token: string): string | null {
    try {
      const parts = token.split('.');
      if (parts.length !== 3) return null;
      let base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
      const padLength = base64.length % 4;
      if (padLength) {
        base64 += '='.repeat(4 - padLength);
      }
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split('')
          .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
          .join('')
      );
      const payload = JSON.parse(jsonPayload);
      if (!payload.tenantId) {
        console.warn('[JwtInterceptor] Valid token but missing tenantId payload field', payload);
      }
      return payload.tenantId || null;
    } catch (e) {
      console.error('[JwtInterceptor] Failed to parse JWT payload for tenantId', e);
      return null;
    }
  }
}
